export const formatPolicyName = (p: string, spaceId: string): string => {
  if (p?.startsWith("//policy.api.mondoo.app/spaces/")) {
    const title = p.split("/").pop();
    return `${spaceId}/${title}`;
  }
  return p?.replace("//policy.api.mondoo.app/policies/", "");
};
